import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Portal from './Portal';
import Icon from './Icon';
import { breakpoints, palette } from '../../constants/styles';

const CloseButton = styled(Icon).attrs({
  icon: 'cross',
  size: 20,
  color: props => props.color,
})`
  pointer: cursor;
  position: fixed;
  top: 10px;
  right: 10px;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 2000;

  ${breakpoints.tablet} {
    position: absolute;
  }
`;

const HoverCardContainer = styled.div``;

const StyledHoverCard = styled.div`
  position: relative;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100vw;
  max-height: ${({ height }) => (Number.isInteger(height) ? `${height}px` : height)};
  margin: ${({ mobileMargin }) => (Number.isInteger(mobileMargin) ? `auto ${mobileMargin}px` : mobileMargin)};
  opacity: 1;
  z-index:1000;

  max-width: ${({ width }) => (Number.isInteger(width) ? `${width}px` : width)};
  max-height: ${({ height }) => (Number.isInteger(height) ? `${height}px` : height)};
  width: 90vw;
  margin: auto;

  ${breakpoints.tabletLandscape} {
    max-width: 700px;
  }

  ${({ roundedCorners }) => roundedCorners && css`
    border-radius: 8px;

  `}

  background-color: ${palette.white};
  color: ${palette.darkerGray};

  z-index: 10000;
  transition: 0.3s;
  animation: mounting 0.3s 1;
  animation-timing-function: ease-out;

  ${({ styles }) => styles}
`;

class HoverCard extends Component {
  state = {};

  render() {
    const {
      children,
      className,
      styles,
      roundedCorners,
      width,
      height,
    } = this.props;

    return (
      <HoverCardContainer>
        <StyledHoverCard
          roundedCorners={roundedCorners}
          width={width}
          height={height}
          className={className}
          styles={styles}
        >
          {children}
        </StyledHoverCard>
      </HoverCardContainer>
    );
  }
}

HoverCard.propTypes = {
  children: PropTypes.func,
  roundedCorners: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  styles: PropTypes.array,
  className: PropTypes.string,
  onCloseHoverCard: PropTypes.func,
};

HoverCard.defaultProps = {
  children: () => { },
  roundedCorners: true,
  width: 1000,
  height: 1000,
  styles: [],
  className: '',
  onCloseHoverCard: () => { },
};

export default HoverCard;
